define('uikit/modules/sidebar.menu',['require','exports','module','underscore','marionette','./menu','../mixins/sidebar.mixin'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var Menu           = require('./menu');
  var SidebarMixin   = require('../mixins/sidebar.mixin');


  var SidebarMenu = Menu.extend(SidebarMixin).extend({

    className: 'ui menu sidebar',

    options: _.extend({}, Menu.prototype.options, {
      insertToBody: true,
      size: null,
      visible: false,
      direction: 'right',
      transition: 'overlay',
      dimPage: true,
      fixed: false,
      hideOnLinkPress: true,
      width: '' //wide, thin or '' (for normal)
    }),

    initialize: function() {
      SidebarMixin.initialize.apply(this, arguments);
      Menu.prototype.initialize.apply(this, arguments);

      if (this.getOption('hideOnLinkPress')) {
        this.on('link:press', function() {
          this.visible = false;
        });
      }
    },

    updateAttributes: function() {
      Menu.prototype.updateAttributes.apply(this, arguments);
      this
        .addClass(this.getOption('direction'), this.getBoolOption('direction'))
        .addClass(this.getOption('size'), this.getBoolOption('size'))
        .addClass(this.getOption('width'), this.getBoolOption('width'))
    }

  });

  module.exports = SidebarMenu;
});

